export default "__VITE_ASSET__CIUUP2Ak__"